import { sequentialWaypointLabel } from '../../routePlanner/io/waypointLabel';

export interface MissionWaypointPin {
  id: string;
  latitude: number;
  longitude: number;
  label: string;
}

export function pinsFromWaypoints(
  waypoints: Array<{
    id?: string | number;
    label?: string | null;
    latitude: number;
    longitude: number;
  }>,
): MissionWaypointPin[] {
  return waypoints
    .filter((w) => Number.isFinite(w.latitude) && Number.isFinite(w.longitude))
    .map((w, index) => ({
      id: String(w.id ?? `wp-${index}`),
      latitude: w.latitude,
      longitude: w.longitude,
      label: sequentialWaypointLabel(w.label, index),
    }));
}
